import { Box } from '@mui/system';
import DataTable from '../DataTable';
import { Button, CircularProgress, Typography } from '@mui/material';
import { useState } from 'react';
import { OfferFeatureSectionProps } from './OfferFeatureSectionType';

const OfferFeatureSection = <T,>({
  offerId,
  title,
  addButtonLabel,
  AddDialogComponent,
  addDialogProps,
  columns,
  data,
  isLoading,
  isError,
  errorMessage,
  getRowId,
  onDeleteSelected,
  enableSelect = false,
  refetchData,
  emptyMessage = 'Brak danych do wyświetlenia.',
  onInlineSave,
  editingRowId,
  setEditingRowId,
  editedRow,
  setEditedRow,
  TemplateSelectorComponent,
}: OfferFeatureSectionProps<T> & { TemplateSelectorComponent?: React.ReactNode }) => {
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [selected, setSelected] = useState<number[]>([]);

  const handleDeleteSelected = async () => {
    if (!onDeleteSelected || selected.length === 0) return;
    await onDeleteSelected(selected);
    setSelected([]);
    refetchData && refetchData();
  };

  if (!offerId) {
    return (
      <Typography color="text.secondary">
        {title
          ? `${title} są dostępne po zapisaniu oferty.`
          : 'Dane są dostępne po zapisaniu oferty.'}
      </Typography>
    );
  }

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <Button variant="contained" onClick={() => setAddDialogOpen(true)}>
          {addButtonLabel}
        </Button>
        {TemplateSelectorComponent}
        {enableSelect && (
          <Button
            variant="outlined"
            color="error"
            onClick={handleDeleteSelected}
            disabled={selected.length === 0}
          >
            Usuń zaznaczone
          </Button>
        )}
      </Box>
      <AddDialogComponent
        open={addDialogOpen}
        onClose={() => {
          setAddDialogOpen(false);
          refetchData && refetchData();
        }}
        {...addDialogProps}
      />
      {isLoading ? (
        <CircularProgress />
      ) : (
        <DataTable
          columns={columns}
          data={data ?? []}
          isLoading={false}
          isError={!!isError}
          errorMessage={errorMessage}
          getRowId={getRowId}
          selected={enableSelect ? selected : undefined}
          onSelectionChange={enableSelect ? setSelected : undefined}
          onInlineSave={onInlineSave}
          editingRowId={editingRowId}
          setEditingRowId={setEditingRowId}
          editedRow={editedRow}
          setEditedRow={setEditedRow}
          emptyMessage={emptyMessage}
        />
      )}
    </Box>
  );
};

export default OfferFeatureSection;
